<template>
  <div>
    <v-card>
      <v-card-text>

        <v-chip-group column>
          <v-chip @click:close="clearSingleFilter({filter:'status',value:[]})" close small v-if="getNumberTransfersConfigs.status.length!==0"><b class="mr-1">Number Transfer Status:</b>{{getNumberTransfersConfigs.status.join(', ')}}</v-chip>
          <v-chip @click:close="clearSingleFilter({filter:'portKind',value:[]})" close small v-if="getNumberTransfersConfigs.portKind.length!==0"><b class="mr-1">Port Kind:</b>{{getNumberTransfersConfigs.portKind.join(', ')}}</v-chip>
          <v-chip @click:close="clearSingleFilter({filter:'productStatus',value:[]})" close small v-if="getNumberTransfersConfigs.productStatus.length!==0"><b class="mr-1">Product Status:</b>{{getNumberTransfersConfigs.productStatus.join(', ')}}</v-chip>
          <v-chip @click:close="clearSingleFilter({filter: 'automatedOrderStatus', value: []})" close small v-if="getNumberTransfersConfigs.automatedOrderStatus.length!==0"><b class="mr-1">Automated Order Status:</b>{{ getNumberTransfersConfigs.automatedOrderStatus.join(', ') }}</v-chip>
        </v-chip-group>

        <v-data-table :loading="getNumberTransfersLoading" :headers="headers" :items="getNumberTransfers" class="body--text" :server-items-length="getNumberTransfersConfigs.paginationCount" :page.sync="getNumberTransfersConfigs.paginationPage" :options.sync="options" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}">
          <template v-slot:header.porting_range_start="{ header }">
            <span class="pr-1">{{ header.text }}</span>
            <BaseInfoTooltip top>The first number in the number transfer range</BaseInfoTooltip>
          </template>

          <template v-slot:header.port_kind="{ header }">
            <span class="pr-1">{{ header.text }}</span>
            <BaseInfoTooltip top>Type of port i.e. geographic</BaseInfoTooltip>
          </template>

          <template v-slot:header.warning_flag="{ header }">
            <span class="pr-1">{{ header.text }}</span>
            <BaseInfoTooltip top>The Service Level Agreement </BaseInfoTooltip>
          </template>

          <template v-slot:header.porting_status="{ header }">
            <span class="pr-1">{{ header.text }}</span>
            <BaseInfoTooltip top>The status of the automated order</BaseInfoTooltip>
          </template>

          <template v-slot:header.cloa_status="{ header }">
            <span class="pr-1">{{ header.text }}</span>
            <BaseInfoTooltip top>Whether the letter of authority has been signed (Customer Level of Authority)</BaseInfoTooltip>
          </template>

          <template v-slot:item.voip_site_id="{ item }"><a :href="`/products/${item.voip_site_id}`">{{ item.voip_site_id | textPlaceholder }}</a></template>
          <template v-slot:item.product_status="{ item }">{{ item.product_status | textPlaceholder }}</template>
          <template v-slot:item.business_name="{ item }">{{ item.business_name | textPlaceholder }}</template>
          <template v-slot:item.porting_range_start="{ item }">{{ item.porting_range_start | textPlaceholder }}</template>
          <template v-slot:item.port_kind="{ item }">{{ item.port_kind | textPlaceholder }}</template>
          <template v-slot:item.number_transfer_status="{ item }">{{ item.status | textPlaceholder }}</template>
          <template v-slot:item.sla_days="{ item }">{{ item.sla_days | textPlaceholder }}</template>
          
          <template v-slot:item.warning_flag="{ item }">
            <template v-if="item.warning_flag">
              <SlaFlagIcon :warningFlag="item.warning_flag"/>
            </template>
            <span v-else>-</span>
          </template>
          
          <template v-slot:item.porting_status="{ item }">{{ item.porting_status | textPlaceholder }}</template>
          <template v-slot:item.confirmed_transfer_date="{ item }">{{ item.confirmed_transfer_date | formatDate }}</template>
          <template v-slot:item.cloa_status="{ item }">{{ item.cloa_status | textPlaceholder }}</template>
          <template v-slot:item.actions="{ item }">
            <template v-if="item.broadband_product_id!==null">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="$router.push(`/products/${item.broadband_product_id}/`)" class="mr-4" fab x-small color="secondary" v-bind="attrs" v-on="on"><v-icon>{{telcoIcon}}</v-icon></v-btn>
                </template>
                <span>Waiting for broadband {{item.broadband_product_id}}</span>
              </v-tooltip>
            </template>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="secondary" class="ml-2" x-small :href="`${queue_url}voip-porting/actions/?product_id=${item.voip_site_id}`" target="_blank"><v-icon small>{{queueIcon}}</v-icon></v-btn>
              </template>
              <span>Porting Queue</span>
            </v-tooltip>
          </template>
        </v-data-table>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import { mdiFormatListText, mdiRouterWireless } from '@mdi/js';
  import SlaFlagIcon from '@/components/NumberTransfers/SlaFlagIcon';

  export default {
    components: {SlaFlagIcon},

    data() {
      return {
        options: {
          itemsPerPage: 50,
          sortBy: [],
          sortDesc: [],
        },
        itemsPerPageOptions: [5,10,15,25,50],
        headers: [
          { text: 'Product ID', value: 'voip_site_id', sortable: false },
          { text: 'Product Status', value: 'product_status', sortable: true },
          { text: 'Business Name', value: 'business_name', sortable: false },
          { text: 'Porting Range Start', value: 'porting_range_start', sortable: false },
          { text: 'Port Kind (Geographic/IPEX/Etc)', value: 'port_kind', sortable: false },
          { text: 'Number Transfer Status', value: 'status', sortable: false },
          { text: 'Days in Status', value: 'sla_days', sortable: false },
          { text: 'SLA', value: 'warning_flag', sortable: false },
          { text: 'Automated Order Status', value: 'porting_status', sortable: false },
          { text: 'Confirmed Transfer Date', value: 'confirmed_transfer_date', sortable: false },
          { text: 'CLOA', value: 'cloa_status', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ],
        queue_url: process.env.VUE_APP_QUEUE_URL || `https://queues-bonline-testing.appspot.com/`,
        queueUrl: '',
        queueIcon: mdiFormatListText,
        telcoIcon: mdiRouterWireless,
      }
    },

    filters: {
      textPlaceholder(val) {
        if(val === null || val === "" || val === undefined) return "-";
        return val;
      },

      formatStatus(val) {
        const map = {"voip": "VoIP", "web": "Website", "telco": "Telco"};
        return map[val];
      }
    },

    computed: {
      ...mapGetters("numberTransfers", ["getNumberTransfers", "getNumberTransfersLoading", "getNumberTransfersConfigs"]),
    },

    methods: {
      ...mapActions("numberTransfers", ["loadNumberTransfers", "updateNumberTransfersPagination"]),

      clearSingleFilter(item){
        let options = {
          portKind: this.getNumberTransfersConfigs.portKind,
          productStatus: this.getNumberTransfersConfigs.productStatus,
          status: this.getNumberTransfersConfigs.status,
          automatedOrderStatus: this.getNumberTransfersConfigs.automatedOrderStatus,
        };
        options[item.filter] = item.value;
        this.updateNumberTransfersPagination(options);
      },

      isEmpty(val) {
        return val === null || val === "" || val === undefined;
      }
    },

    watch: {
      immediate: false,
      options: {
        handler () {
          this.updateNumberTransfersPagination(this.options);
        },
        deep: true,
      },
    },
  }
</script>

<style>

</style>
